module.exports = __webpack_public_path__ + "images/icons/logos/italy-black-2fc90ce3.svg";